import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const WarehouseItemTypeRoutes = defineRoute({
    record: {
        route: {
            path: "/warehouse-item-type",
            component: () => loadView(import("./WarehouseItemTypeTable.vue")),
        },
    },
    create: {
        route: {
            path: "/warehouse-item-type/create",
            component: () => loadView(import("./WarehouseItemTypeCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/warehouse-item-type/update/:id",
            component: () => loadView(import("./WarehouseItemTypeUpdate.vue")),
        },
        build(id: string) {
            return `/warehouse-item-type/update/${id}`;
        },
    },
});
